
//Libraries
import { defineComponent, onMounted, onUnmounted } from "vue";

//Services
import { manipulateScroll } from "../services/dom-service";

export default defineComponent({
  name: "NotificationBar",
  setup() {
    //Lifecycle Hooks

    setTimeout(() => {
      document.getElementById("notificationbar-body")?.classList.add("isActive");
    }, 50);

    onMounted(() => {
      manipulateScroll(false);
    });

    onUnmounted(() => {
      manipulateScroll(true);
    });
  },
});
